import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { IconCross } from '@xingternal/icons';
import { ProgressBar } from '@xingternal/progress-bar';
import styles from './filePreview.css';
import FileThumbnail from './FileThumbnail';

const FilePreview = ({ file, uploadProgress, onRemoveFile }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    if (file.type.startsWith('image')) {
      const objectURL = URL.createObjectURL(file);
      setThumbnailUrl(objectURL);

      return () => {
        URL.revokeObjectURL(objectURL);
      };
    }
    return undefined;
  }, [file.type, file.size]);

  const { metaId, name, type, humanReadableSize } = file;
  const fileWasUploaded = uploadProgress === 1;

  return (
    <div key={metaId} className={styles.previewContainer}>
      <div className={styles.metaContainer}>
        {!fileWasUploaded ? (
          <ProgressBar
            className={styles.progressBar}
            labelText={intl.formatMessage({ id: 'CONTACT_FORM_FILE_UPLOAD_PROGRESS_SUFFIX' })}
            progress={Math.round(uploadProgress * 100)}
            showLabel
            textPositioning="left"
            textVariant="lighter"
            variant="determinate"
          />
        ) : (
          <>
            <FileThumbnail type={type} thumbnailUrl={thumbnailUrl} />
            <div className={styles.metaText}>
              <span className={styles.fileName}>{name}</span>
              <span className={styles.fileSize}>{humanReadableSize}</span>
            </div>
          </>
        )}
      </div>
      {fileWasUploaded && (
        <div className={styles.actions}>
          <IconCross
            width={22}
            height={22}
            className={styles.removeFileButton}
            onClick={onRemoveFile}
          />
        </div>
      )}
    </div>
  );
};

FilePreview.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    lastModified: PropTypes.number,
    metaId: PropTypes.string,
    type: PropTypes.string,
    humanReadableSize: PropTypes.string,
  }).isRequired,
  uploadProgress: PropTypes.number.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

export default FilePreview;
